import type { FC } from 'react';

import RatingList from './Detail/RatingList';

interface RatingContainerProps {
    data: any;
}

const RatingEntityContent: FC<RatingContainerProps> = ({ data }) => {
    return (
        <>
            <RatingList assigneeId={data?.id} />
        </>
    );
};

export default RatingEntityContent;
